// // //Commented out some stuff that wasn't getting used yet to get the cmd prompt to quiet down
// // // import React, {useState,useEffect } from 'react';
// // // //import { Calendar } from 'react-date-range';
// // // import axios from 'axios';
// // // import { app } from '../firebase/firebase-config';
// // // import { getAuth, updatePassword, updateEmail, reauthenticateWithCredential } from 'firebase/auth';

// // // const auth = getAuth(app);
// // // const Schedule = ()=> {
// // //     const [userDetails, setUserDetails]=  useState({});
// // // 	//Get all the appointments related to the healer.

// // //     useEffect(() => {
// // // 		//let userD = "";
// // // 		//this method checks if the user is authenticated with firebase and essentially logged in.
// // // 		auth.onAuthStateChanged( async (user) => {
// // // 			console.log(user);
// // // 			//setUserState(user);
// // // 			if(user){
// // // 				await axios.get('http://localhost:8080/users').then(  (response) => {
// // // 					////self added in from CodeGuru
// // // 					//setUserDetails(chosenUser);
// // // 					console.log(response.data);
// // // 					for(const i of response.data){
// // // 						if (i.email.toLowerCase() == user.email.toLowerCase()){
// // // 							console.log(i);
// // // 							setUserDetails(i);
// // // 							//userD = i;
// // // 						}
// // // 					}
// // // 				});
// // // 			}
// // // 		});	
// // // 	}, []); 
// // // 	return(
// // // 	<>
// // // 		<ConfirmBox userDetails = {userDetails}></ConfirmBox>
// // // 		<HistoryBox userDetails={userDetails}></HistoryBox>
// // // 	</>
// // // 	)
// // // }

// // // const HistoryBox = ({userDetails})=> {
// // // 	var appointmentsArray = [];
// // // 	console.log(userDetails);
// // // 	const [history, setHistory] = useState([{client: 1}]);
// // // 	const [render, setRender] = useState([]);
// // // 	var endpoint = "appointments";
// // 	if(userDetails.account == 1){   //if the user who log in is the healer
// // 		endpoint = "appointments?healer="+ userDetails.uid;   //get the information of all the appointments the healer has set up/
// // 	}
// // 	else{
// // 		endpoint = "appointments/clients/"+userDetails.uid;   //get all the information of all the appointments the client has entered.
// // 	}
// // 	useEffect(()=>{
// // 		axios.get("http://localhost:8080/"+ endpoint)
// // 		.then(result=> {
// // 			console.log(result.data);
// // 			setHistory(result.data);
// // 		})
// // 		.catch(err=> {
// // 			console.log("Error with viewing history appointments: "+ err);
// // 		})
// // 	}, [userDetails])


// // 	return(
// // 		<>
// // 			<h3>Appointment history</h3>
// // 			{
// // 				history.map(appointment=> {
// // 					console.log(appointment);
// // 					return(
// // 						<>
// // 							<ClientBox appointment = {appointment} user = {userDetails}></ClientBox>
// // 						</>
// // 					)
// // 				})
// // 			}
// // 		</>

// // 	)
// // }

// // const ConfirmBox = ({userDetails})=> {
// //     console.log(userDetails);
// //     const [healerAppointment, setHealerAppointment] = useState([{client: 1}]);
// // 	const [confirm, setConfirm] = useState([]);   //detects whether to reload or not.
// // 	const [clientInfo, setClientInfo] = useState({});
// //     var arrayConfirm = [];
// //     useEffect(()=> {  //think of someway so that the useEffect run for the first time and then, run for every time the button is pressed.   
// // 		axios.get("http://localhost:8080/appointments?healer="+userDetails.uid)
// // 		.then((response)=> {
// // 			console.log(response.data);
// // 			const a = [];
// // 			response.data.map(x => {
// // 				if(x.healerAccepted == null){
// // 					a.push(x);
// // 				}
// // 			})
// // 			//setHealerAppointment(response.data);
// // 			setHealerAppointment(a);
// // 		})
// // 		.catch(err=> {
// // 			console.log("Error at schedule: "+ err);
// // 		})
// // 	}, [userDetails, confirm]);

// // 	return (
// // 		<div className = "reviewContainer">
// // 			<br></br>
// // 			<h3>Upcoming appointments</h3>
// // 			{
// // 				healerAppointment.map(appointment=> {
// // 					return (
// // 						<div key = {appointment.aid}>
// // 							<ClientBox appointment = {appointment} user = {userDetails}></ClientBox>
// // 							{userDetails.account == 1 ? 
// // 							<>
// // 									<ConfirmButton appointment = {appointment} confirm = {1} healerID = {userDetails.uid} arrayConfirm = {arrayConfirm} setConfirm = {setConfirm}></ConfirmButton>
// // 									<ConfirmButton appointment = {appointment} confirm = {0} healerID = {userDetails.uid} arrayConfirm = {arrayConfirm} setConfirm = {setConfirm}></ConfirmButton> 
// // 							</>
// // 									:
// // 									<CancelButton appointment = {appointment}></CancelButton> 
// // 							}
// // 							<br></br>
// // 						</div>
// // 					)
// // 				})
// // 			}
// // 		</div>
// // 	)
// // }

// // const ClientBox = ({appointment, user})=> {  //appointment can contain both the healer and the client's information.
// // 	console.log(user);
// // 	console.log(appointment);
// // 	const [clientInfo, setClientInfo] = useState({});
// // 	var receiver = "Client:"
// // 	var endpoint = "1";
// // 	if(appointment != null){
// // 		console.log(appointment);
// // 		if(user.account == 1){
// // 			endpoint = appointment.healer;
// // 		}
// // 		else{
// // 			endpoint = appointment.client;
// // 			receiver = "Healer: "
// // 		}
// // 	}

// // 	useEffect(()=> {
// // 		axios.get("http://localhost:8080/users/"+ endpoint)
// // 		.then(result=> {
// // 			console.log(result.data);
// // 			setClientInfo(result.data)
// // 		})
// // 		.catch(err=> {
// // 			console.log("There is an issue with catching the client info: "+ err);
// // 		})
// // 	}, [])  //re-render whenever there is a new appointment
// // 	return(
// // 		<div>
// // 			<p> {receiver} {clientInfo.firstname + " "+ clientInfo.lastname}</p>
// // 			<p>Time: {appointment.time}</p>
// // 			<p>Date: {appointment.date}</p>
// // 		</div>
// // 	)
// // }
// // const Loading = ()=> {
// // 	return(
// // 		<p>Still loading</p>
// // 	)
// // }

// // //the confirm/deny button
// // const ConfirmButton = ({appointment, confirm, healerID, arrayConfirm, setConfirm})=> {
// // 	var confirmText = "";
// // 	if(confirm == 1){
// // 		confirmText = "Confirm";
// // 	}
// // 	else if(confirm == 0){
// // 		confirmText = "Deny";
// // 	}
// // 	return(
// // 		<button  onClick = {()=> {axios.put('http://localhost:8080/appointments/'+appointment.aid, {
// // 			healerAccepted: confirm, 
// // 			client: appointment.client, 
// // 			aid: appointment.aid,
// // 			healer: healerID, 
// // 			timezone: appointment.timezone,
// // 			date: appointment.date, 
// // 			time: appointment.time, 
// // 			createdAt: Date.now(), 
// // 			updatedAt: Date.now()
// // 		})
// // 		.then((response)=> {
// // 			console.log(response.data);
// // 			arrayConfirm.push(true);
// // 			setConfirm(arrayConfirm);
// // 		})

// // 		}
// // 		}  >{confirmText}</button>
// // 	)

// // }

// // const CancelButton = ({appointment})=> {
// // 	return(
// // 		<>
// // 			<button  onClick = {()=> {axios.delete("http://localhost:8080/appointments/"+ appointment.aid)
// // 		.then(result=> {
// // 			console.log(result.data);

// // 		})
// // 		.catch(err=> {
// // 			console.log("Something wrong when deleting appoitnments"+ err);
// // 		})

// // 		}
// // 		}>Deny</button>
// // 		</>
// // 	)
// // }

// // export default Schedule;

// //------------------------------------------------------------------------------------------


// // import React, { useState, useEffect } from 'react';
// // import axios from 'axios';
// // import { app } from '../firebase/firebase-config';
// // import { getAuth } from 'firebase/auth';
// // import { Container, Box, Typography, Button, CircularProgress, Paper, Grid } from '@material-ui/core';

// // const auth = getAuth(app);

// // const Schedule = () => {
// //     const [userDetails, setUserDetails] = useState({});

// //     useEffect(() => {
// //         auth.onAuthStateChanged(async (user) => {
// //             if (user) {
// //                 await axios.get('http://localhost:8080/users').then((response) => {
// //                     for (const i of response.data) {
// //                         if (i.email.toLowerCase() === user.email.toLowerCase()) {
// //                             setUserDetails(i);
// //                         }
// //                     }
// //                 });
// //             }
// //         });
// //     }, []);

// //     return (
// //         <Container>
// //             <ConfirmBox userDetails={userDetails} />
// //             <HistoryBox userDetails={userDetails} />
// //         </Container>
// //     );
// // };

// // const HistoryBox = ({ userDetails }) => {
// //     const [history, setHistory] = useState([]);
// //     const [loading, setLoading] = useState(true);
// //     const endpoint = userDetails.account === 1 ? `appointments?healer=${userDetails.uid}` : `appointments/clients/${userDetails.uid}`;

// //     useEffect(() => {
// //         axios.get(`http://localhost:8080/${endpoint}`)
// //             .then(result => {
// //                 setHistory(result.data);
// //                 setLoading(false);
// //             })
// //             .catch(err => {
// //                 console.error("Error with viewing history appointments: ", err);
// //                 setLoading(false);
// //             });
// //     }, [userDetails, endpoint]);

// //     if (loading) {
// //         return <CircularProgress />;
// //     }

// //     return (
// //         <Box my={4}>
// //             <Typography variant="h5">Appointment History</Typography>
// //             {history.map((appointment, index) => (
// //                 <Paper key={index} style={{ padding: '16px', marginBottom: '16px' }}>
// //                     <ClientBox appointment={appointment} user={userDetails} />
// //                 </Paper>
// //             ))}
// //         </Box>
// //     );
// // };

// // const ConfirmBox = ({ userDetails }) => {
// //     const [healerAppointment, setHealerAppointment] = useState([]);
// //     const [confirm, setConfirm] = useState([]);

// //     useEffect(() => {
// //         axios.get(`http://localhost:8080/appointments?healer=${userDetails.uid}`)
// //             .then((response) => {
// //                 const pendingAppointments = response.data.filter(x => x.healerAccepted === null);
// //                 setHealerAppointment(pendingAppointments);
// //             })
// //             .catch(err => {
// //                 console.error("Error at schedule: ", err);
// //             });
// //     }, [userDetails, confirm]);

// //     return (
// //         <Box my={4}>
// //             <Typography variant="h5">Upcoming Appointments</Typography>
// //             {healerAppointment.map((appointment, index) => (
// //                 <Paper key={index} style={{ padding: '16px', marginBottom: '16px' }}>
// //                     <ClientBox appointment={appointment} user={userDetails} />
// //                     {userDetails.account === 1 ?
// //                         <Grid container spacing={2}>
// //                             <Grid item>
// //                                 <ConfirmButton appointment={appointment} confirm={1} healerID={userDetails.uid} setConfirm={setConfirm} />
// //                             </Grid>
// //                             <Grid item>
// //                                 <ConfirmButton appointment={appointment} confirm={0} healerID={userDetails.uid} setConfirm={setConfirm} />
// //                             </Grid>
// //                         </Grid>
// //                         :
// //                         <CancelButton appointment={appointment} />
// //                     }
// //                 </Paper>
// //             ))}
// //         </Box>
// //     );
// // };

// // const ClientBox = ({ appointment, user }) => {
// //     const [clientInfo, setClientInfo] = useState({});
// //     const endpoint = user.account === 1 ? appointment.client : appointment.healer;
// //     const receiver = user.account === 1 ? "Client:" : "Healer:";

// //     useEffect(() => {
// //         axios.get(`http://localhost:8080/users/${endpoint}`)
// //             .then(result => {
// //                 setClientInfo(result.data);
// //             })
// //             .catch(err => {
// //                 console.error("There is an issue with catching the client info: ", err);
// //             });
// //     }, [endpoint]);

// //     return (
// //         <Box>
// //             <Typography variant="body1">{receiver} {clientInfo.firstName} {clientInfo.lastName}</Typography>
// //             <Typography variant="body1">Time: {appointment.time}</Typography>
// //             <Typography variant="body1">Date: {appointment.date}</Typography>
// //         </Box>
// //     );
// // };

// // const ConfirmButton = ({ appointment, confirm, healerID, setConfirm }) => {
// //     const handleConfirm = () => {
// //         axios.put(`http://localhost:8080/appointments/${appointment.aid}`, {
// //             healerAccepted: confirm,
// //             client: appointment.client,
// //             aid: appointment.aid,
// //             healer: healerID,
// //             timezone: appointment.timezone,
// //             date: appointment.date,
// //             time: appointment.time,
// //             createdAt: Date.now(),
// //             updatedAt: Date.now()
// //         })
// //             .then(() => {
// //                 setConfirm(prev => !prev);
// //             })
// //             .catch(err => {
// //                 console.error("Error confirming appointment: ", err);
// //             });
// //     };

// //     return (
// //         <Button variant="contained" color={confirm === 1 ? "primary" : "secondary"} onClick={handleConfirm}>
// //             {confirm === 1 ? "Confirm" : "Deny"}
// //         </Button>
// //     );
// // };

// // const CancelButton = ({ appointment }) => {
// //     const handleCancel = () => {
// //         axios.delete(`http://localhost:8080/appointments/${appointment.aid}`)
// //             .then(() => {
// //                 console.log("Appointment cancelled");
// //             })
// //             .catch(err => {
// //                 console.error("Error cancelling appointment: ", err);
// //             });
// //     };

// //     return (
// //         <Button variant="contained" color="secondary" onClick={handleCancel}>
// //             Cancel
// //         </Button>
// //     );
// // };

// // export default Schedule;

// //-----------------------------------------------------------------------------------------------------------



// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { app } from '../firebase/firebase-config';
// import { getAuth } from 'firebase/auth';
// import { Container, Box, Typography, Button, CircularProgress, Paper, Grid, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from '@material-ui/core';

// const auth = getAuth(app);

// const Schedule = () => {
//     const [userDetails, setUserDetails] = useState({});
//     const [view, setView] = useState("0");
//     useEffect(() => {

// 		//let userD = "";
// 		//this method checks if the user is authenticated with firebase and essentially logged in.
// 		auth.onAuthStateChanged( async (user) => {
// 			console.log(user);
// 			//setUserState(user);
// 			if(user){
// 				await axios.get('http://localhost:8080/users').then(  (response) => {
// 					////self added in from CodeGuru
// 					//setUserDetails(chosenUser);
// 					console.log(response.data);
// 					for(const i of response.data){
// 						if (i.email.toLowerCase() == user.email.toLowerCase()){
// 							console.log(i);
// 							setUserDetails(i);
// 							break;
// 							//userD = i;
// 						}
// 					}
// 				});
// 				// return (
// 				// 	<ConfirmBox healer = {userDetails.uid}></ConfirmBox>
// 				// )
// 			}
// 		});	
// 	}, []);

//     return (
//         <Container>
//             {userDetails.account == 1?
//                 <>
//                      <Button  onClick = {()=> {
//                         alert("Set to client view");
//                         setView("0");
//                     }}style = {view == "0"? {"backgroundColor": "green", "marginRight": "20px"}: {"backgroundColor": "#9D96B8", "marginRight": "20px"}}>View as the Client</Button>
//                     <Button  onClick = {()=> {
//                         alert("Set to healer view");
//                         setView("1");
//                     }}style = {view == "1"? {"backgroundColor": "green", "marginRight": "20px"}: {"backgroundColor": "#9D96B8", "marginRight": "20px"}}>View as the Healer</Button>
//                 </>
//                 :
//                 <p></p>
//             }

//             <ConfirmBox userDetails={userDetails} view = {view}/>
//             <HistoryBox userDetails={userDetails} view = {view} />
//         </Container>
//     );
// };

// const HistoryBox = ({ userDetails, view}) => {
//     const [history, setHistory] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const endpoint = userDetails.account === 1 ? `appointments?healer=${userDetails.uid}` : `appointments/clients/${userDetails.uid}`;

//     useEffect(() => {
//         axios.get(`http://localhost:8080/${endpoint}`)
//             .then(result => {
//                 setHistory(result.data);
//                 setLoading(false);
//             })
//             .catch(err => {
//                 console.error("Error with viewing history appointments: ", err);
//                 setLoading(false);
//             });
//     }, [userDetails, endpoint]);

//     if (loading) {
//         return <CircularProgress />;
//     }

//     return (
//                 <Box my={4}>
//                     <Typography variant="h5">Appointment History</Typography>
//                     {history.map((appointment, index) => (
//                         <Paper key={index} style={{ padding: '16px', marginBottom: '16px' }}>
//                             <ClientBox appointment={appointment} user={userDetails} />
//                         </Paper>
//                     ))}
//                 </Box>
//             );
// }
// // <<<<<<< HEAD
// //     return (
// //         <Box my={4}>
// //             <Typography variant="h5">Appointment History</Typography>
// //             {history.map((appointment, index) => (
// //                 <Paper key={index} style={{ padding: '16px', marginBottom: '16px' }}>
// //                     <ClientBox appointment={appointment} user={userDetails} />
// //                 </Paper>
// //             ))}
// //         </Box>
// //     );
// // };
// // =======
// // 	return (
// // 		<div className = "reviewContainer">
// // 			<br></br>
// // 			<h3>Upcoming appointments</h3>
// // 			{
// // 				// useEffect(()=> {
// // 				// 	console.log(healerAppointment);
// // 				// 	healerAppointment.map(appointment=> {
// // 				// 		return (
// // 				// 			<div key = {appointment.aid}>
// // 				// 				<ClientBox appointment = {appointment} user = {userDetails}></ClientBox>
// // 				// 				{userDetails.account == 1 ? 
// // 				// 				<>
// // 				// 						<ConfirmButton appointment = {appointment} confirm = {1} healerID = {userDetails.uid} arrayConfirm = {arrayConfirm} setConfirm = {setConfirm}></ConfirmButton>
// // 				// 						<ConfirmButton appointment = {appointment} confirm = {0} healerID = {userDetails.uid} arrayConfirm = {arrayConfirm} setConfirm = {setConfirm}></ConfirmButton> 
// // 				// 				</>
// // 				// 						:
// // 				// 						<CancelButton appointment = {appointment}></CancelButton> 
// // 				// 				}
// // 				// 				<br></br>
// // 				// 			</div>
// // 				// 		)
// // 				// 	})
// // 				// })
// // 				healerAppointment.map(appointment=> {
// // 					console.log(appointment);
// // 					return (
// // 						<div key = {appointment.aid}>
// // 							<ClientBox appointment = {appointment} user = {userDetails}></ClientBox>
// // 							{userDetails.account == 1 ? 
// // 							<>
// // 									<ConfirmButton appointment = {appointment} confirm = {1} healerID = {userDetails.uid} arrayConfirm = {arrayConfirm} setConfirm = {setConfirm}></ConfirmButton>
// // 									<ConfirmButton appointment = {appointment} confirm = {0} healerID = {userDetails.uid} arrayConfirm = {arrayConfirm} setConfirm = {setConfirm}></ConfirmButton> 
// // 							</>
// // 									:
// // 									<CancelButton appointment = {appointment}></CancelButton> 
// // 							}
// // 							<br></br>
// // 						</div>
// // 					)
// // 				})
// // 			}
// // 		</div>
// // 	)
// // }
// // >>>>>>> 793abc4e4b5b2a9cd95f857be617365eee8908e5

// const ConfirmBox = ({ userDetails, view }) => {
//     const [healerAppointment, setHealerAppointment] = useState([]);
//     const [confirm, setConfirm] = useState([]);

//     useEffect(() => {
//         view == "1"?  //if the healer wants to be viewed as client or healer
//         axios.get(`http://localhost:8080/appointments?healer=${userDetails.uid}`)
//             .then((response) => {
//                 const pendingAppointments = response.data.filter(x => x.healerAccepted === null);
//                 setHealerAppointment(pendingAppointments);
//             })
//             .catch(err => {
//                 console.error("Error at schedule: ", err);
//             })
//         :
//         axios.get(`http://localhost:8080/appointments/clients/${userDetails.uid}`)
//         .then((response) => {
//             const pendingAppointments = response.data.filter(x => x.healerAccepted === null);
//             setHealerAppointment(pendingAppointments);
//         })
//         .catch(err => {
//             alert("Error at schedule: ", err);
//         });
//     }, [userDetails, confirm, view]);

//     return (
//         <Box my={4}>
//             <Typography variant="h5">Upcoming Appointments</Typography>
//             {healerAppointment.map((appointment, index) => (
//                 <Paper key={index} style={{ padding: '16px', marginBottom: '16px' }}>
//                     <ClientBox appointment={appointment} user={userDetails} />
//                     {/* {userDetails.account === 1 ? */}
//                     {view == "1" ? 
//                       <Grid container spacing={2}>
//                       <Grid item>
//                           <ConfirmButton appointment={appointment} confirm={1} healerID={userDetails.uid} setConfirm={setConfirm} />
//                       </Grid>
//                       <Grid item>
//                           <ConfirmButton appointment={appointment} confirm={0} healerID={userDetails.uid} setConfirm={setConfirm} />
//                       </Grid>
//                       <Grid item>
//                           <RescheduleButton appointment={appointment} setConfirm={setConfirm} />
//                       </Grid>
//                   </Grid>
//                   :
//                   <CancelButton appointment={appointment} />}
//                 </Paper>
//             ))}
//         </Box>
//     );
// };

// const ClientBox = ({ appointment, user }) => {
//     const [clientInfo, setClientInfo] = useState({});
//     const endpoint = user.account === 1 ? appointment.client : appointment.healer;
//     const receiver = user.account === 1 ? "Client:" : "Healer:";

//     useEffect(() => {
//         axios.get(`http://localhost:8080/users/${endpoint}`)
//             .then(result => {
//                 setClientInfo(result.data);
//             })
//             .catch(err => {
//                 console.error("There is an issue with catching the client info: ", err);
//             });
//     }, [endpoint]);

//     return (
//         <Box>
//             <Typography variant="body1">{receiver} {clientInfo.firstName} {clientInfo.lastName}</Typography>
//             <Typography variant="body1">Time: {appointment.time}</Typography>
//             <Typography variant="body1">Date: {appointment.date}</Typography>
//             <Typography variant="body1">Service: {appointment.appointmentService}</Typography>
//         </Box>
//     );
// };

// const ConfirmButton = ({ appointment, confirm, healerID, setConfirm }) => {
//     const handleConfirm = () => {
//         axios.put(`http://localhost:8080/appointments/${appointment.aid}`, {
//             healerAccepted: confirm,
//             client: appointment.client,
//             aid: appointment.aid,
//             healer: healerID,
//             timezone: appointment.timezone,
//             date: appointment.date,
//             time: appointment.time,
//             createdAt: Date.now(),
//             updatedAt: Date.now()
//         })
//             .then(() => {
//                 setConfirm(prev => !prev);
//             })
//             .catch(err => {
//                 console.error("Error confirming appointment: ", err);
//             });
//     };

//     return (
//         <Button variant="contained" color={confirm === 1 ? "primary" : "secondary"} onClick={handleConfirm}>
//             {confirm === 1 ? "Confirm" : "Deny"}
//         </Button>
//     );
// };

// const CancelButton = ({ appointment }) => {    //cancel the appointment and make a re-fund feature(not yet).
//     const handleCancel = () => {
//         axios.delete(`http://localhost:8080/appointments/${appointment.aid}`)
//             .then(() => {
//                 alert("Appointment cancelled");
//             })
//             .catch(err => {
//                 console.error("Error cancelling appointment: ", err);
//             });
//     };

//     return (
//         <Button variant="contained" color="secondary" onClick={handleCancel}>
//             Cancel
//         </Button>
//     );
// };

// const RescheduleButton = ({ appointment, setConfirm }) => {
//     const [open, setOpen] = useState(false);
//     const [newDate, setNewDate] = useState(appointment.date);
//     const [newTime, setNewTime] = useState(appointment.time);

//     const handleClickOpen = () => {
//         setOpen(true);
//     };

//     const handleClose = () => {
//         setOpen(false);
//     };

//     const handleReschedule = () => {
//         axios.put(`http://localhost:8080/appointments/${appointment.aid}`, {
//             ...appointment,
//             date: newDate,
//             time: newTime,
//             updatedAt: Date.now()
//         })
//             .then(() => {
//                 setConfirm(prev => !prev);
//                 handleClose();
//             })
//             .catch(err => {
//                 console.error("Error rescheduling appointment: ", err);
//             });
//     };

//     return (
//         <>
//             <Button variant="contained" onClick={handleClickOpen}>
//                 Reschedule
//             </Button>
//             <Dialog open={open} onClose={handleClose}>
//                 <DialogTitle>Reschedule Appointment</DialogTitle>
//                 <DialogContent>
//                     <TextField
//                         label="New Date"
//                         type="date"
//                         defaultValue={newDate}
//                         onChange={(e) => setNewDate(e.target.value)}
//                         fullWidth
//                         margin="normal"
//                     />
//                     <TextField
//                         label="New Time"
//                         type="time"
//                         defaultValue={newTime}
//                         onChange={(e) => setNewTime(e.target.value)}
//                         fullWidth
//                         margin="normal"
//                     />
//                 </DialogContent>
//                 <DialogActions>
//                     <Button onClick={handleClose} color="primary">
//                         Cancel
//                     </Button>
//                     <Button onClick={handleReschedule} color="primary">
//                         Reschedule
//                     </Button>
//                 </DialogActions>
//             </Dialog>
//         </>
//     );
// };

// export default Schedule;


// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { app } from '../firebase/firebase-config';
// import { getAuth } from 'firebase/auth';
// import {
//   Container, Box, Typography, Button, CircularProgress, Paper, Grid,
//   Dialog, DialogTitle, DialogContent, DialogActions, TextField
// } from '@material-ui/core';

// const auth = getAuth(app);

// const Schedule = () => {
//   const [userDetails, setUserDetails] = useState({});
//   const [view, setView] = useState("0");

//   useEffect(() => {
//     auth.onAuthStateChanged(async (user) => {
//       if (user) {
//         console.log("Firebase User Authenticated:", user);
//         try {
//           const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/users`);
//           const matchedUser = res.data.find(i => i.email.toLowerCase() === user.email.toLowerCase());
//           if (matchedUser) {
//             console.log("Matched user details:", matchedUser);
//             setUserDetails(matchedUser);
//           }
//         } catch (err) {
//           console.error("Error fetching users:", err);
//         }
//       }
//     });
//   }, []);

//   return (
//     <Container>
//       {userDetails.account === 1 && (
//         <>
//           <Button onClick={() => setView("0")}
//             style={{ backgroundColor: view === "0" ? "green" : "#9D96B8", marginRight: "20px" }}>
//             View as Client
//           </Button>
//           <Button onClick={() => setView("1")}
//             style={{ backgroundColor: view === "1" ? "green" : "#9D96B8" }}>
//             View as Healer
//           </Button>
//         </>
//       )}
//       <ConfirmBox userDetails={userDetails} view={view} />
//       <HistoryBox userDetails={userDetails} view={view} />
//     </Container>
//   );
// };

// const HistoryBox = ({ userDetails, view }) => {
//   const [history, setHistory] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const endpoint = userDetails.account === 1 && view === "1"
//     ? `appointments?healer=${userDetails.uid}`
//     : `appointments/clients/${userDetails.uid}`;

// //   useEffect(() => {
// //     if (!userDetails.uid) return;
// //     console.log("Fetching appointment history from:", endpoint);
// //     axios.get(`http://localhost:8080/${endpoint}`)
// //       .then(res => {
// //         console.log("Fetched appointment history:", res.data);
// //         setHistory(res.data);
// //         setLoading(false);
// //       })
// //       .catch(err => {
// //         console.error("Error fetching history:", err);
// //         setLoading(false);
// //       });
// //   }, [userDetails, view]);

// // useEffect(() => {
// //   if (!userDetails.uid) return;

// //   const fetchHistory = () => {
// //     console.log("Fetching appointment history from:", endpoint);
// //     axios.get(`http://localhost:8080/${endpoint}`)
// //       .then(res => {
// //         console.log("Fetched appointment history:", res.data);
// //         setHistory(res.data);
// //         setLoading(false);
// //       })
// //       .catch(err => {
// //         console.error("Error fetching history:", err);
// //         setLoading(false);
// //       });
// //   };

// //   fetchHistory();

// //   // 🔁 Check for new booking every second
// //   const interval = setInterval(() => {
// //     if (localStorage.getItem('appointmentJustBooked') === 'true') {
// //       console.log("📢 New appointment booked! Refreshing...");
// //       localStorage.removeItem('appointmentJustBooked');
// //       fetchHistory();
// //     }
// //   }, 1000);

// //   return () => clearInterval(interval);
// // }, [userDetails, view]);

// useEffect(() => {
//   if (!userDetails.uid) return;

//   const fetchHistory = () => {
//     const storedAppointment = localStorage.getItem('latestAppointment');
//     const latest = storedAppointment ? [JSON.parse(storedAppointment)] : [];

//     console.log("Fetching appointment history from:", endpoint);

//     axios.get(`${process.env.REACT_APP_API_BASE_URL}/${endpoint}`)
//       .then(res => {
//         console.log("Fetched appointment history:", res.data);
//         const fullHistory = [...latest, ...res.data];
//         setHistory(fullHistory);
//         setLoading(false);
//         localStorage.removeItem('latestAppointment'); // optional
//       })
//       .catch(err => {
//         console.error("Error fetching history:", err);
//         setLoading(false);
//       });
//   };

//   fetchHistory();

//   const interval = setInterval(() => {
//     if (localStorage.getItem('appointmentJustBooked') === 'true') {
//       console.log("📢 New appointment booked! Refreshing...");
//       localStorage.removeItem('appointmentJustBooked');
//       fetchHistory();
//     }
//   }, 1000);

//   return () => clearInterval(interval);
// }, [userDetails, view]);



//   if (loading) return <CircularProgress />;

//   return (
//     <Box my={4}>
//       <Typography variant="h5">Appointment History</Typography>
//       {history.map((appointment, index) => {
//         console.log("Rendering appointment row:", appointment);
//         return (
//           <Paper key={index} style={{ padding: 16, marginBottom: 16 }}>
//             <ClientBox appointment={appointment} user={userDetails} />
//           </Paper>
//         );
//       })}
//     </Box>
//   );
// };

// const ConfirmBox = ({ userDetails, view }) => {
//   const [healerAppointment, setHealerAppointment] = useState([]);
//   const [confirm, setConfirm] = useState(false);

//   useEffect(() => {
//     if (!userDetails.uid) return;
//     const url = view === "1"
//       ? `http://localhost:8080/appointments?healer=${userDetails.uid}`
//       : `http://localhost:8080/appointments/clients/${userDetails.uid}`;

//     axios.get(url)
//       .then(res => {
//         const pending = res.data.filter(a => a.healerAccepted === null);
//         setHealerAppointment(pending);
//       })
//       .catch(err => console.error("Error in ConfirmBox:", err));
//   }, [userDetails, view, confirm]);

//   return (
//     <Box my={4}>
//       <Typography variant="h5">Upcoming Appointments</Typography>
//       {healerAppointment.map((appointment, index) => (
//         <Paper key={index} style={{ padding: 16, marginBottom: 16 }}>
//           <ClientBox appointment={appointment} user={userDetails} />
//           {view === "1" ? (
//             <Grid container spacing={2}>
//               <Grid item>
//                 <ConfirmButton appointment={appointment} confirm={1} healerID={userDetails.uid} setConfirm={setConfirm} />
//               </Grid>
//               <Grid item>
//                 <ConfirmButton appointment={appointment} confirm={0} healerID={userDetails.uid} setConfirm={setConfirm} />
//               </Grid>
//               <Grid item>
//                 <RescheduleButton appointment={appointment} setConfirm={setConfirm} />
//               </Grid>
//             </Grid>
//           ) : (
//             <CancelButton appointment={appointment} />
//           )}
//         </Paper>
//       ))}
//     </Box>
//   );
// };

// const ClientBox = ({ appointment, user }) => {
//   const [clientInfo, setClientInfo] = useState({});
//   const endpoint = user.account === 1 ? appointment.client : appointment.healer;
//   const receiver = user.account === 1 ? "Client" : "Healer";

//   useEffect(() => {
//     axios.get(`${process.env.REACT_APP_API_BASE_URL}/users/${endpoint}`)
//       .then(res => setClientInfo(res.data))
//       .catch(err => console.error("Error fetching client info:", err));
//   }, [endpoint]);

//   return (
//     <Box>
//       <Typography variant="body1">{receiver}: {clientInfo.firstname} {clientInfo.lastname}</Typography>
//       <Typography variant="body1">Time: {appointment.time}</Typography>
//       <Typography variant="body1">Date: {appointment.date}</Typography>
//       <Typography variant="body1">Service: {appointment.service || appointment.service_name}</Typography>
//     </Box>
//   );
// };

// const ConfirmButton = ({ appointment, confirm, healerID, setConfirm }) => {
//   const handleConfirm = () => {
//     axios.put(`${process.env.REACT_APP_API_BASE_URL}/appointments/${appointment.aid}`, {
//       ...appointment,
//       healerAccepted: confirm,
//       healer: healerID,
//       updatedAt: Date.now(),
//     })
//       .then(() => {
//         setConfirm(prev => !prev);
//       })
//       .catch(err => console.error("Error confirming appointment:", err));
//   };

//   return (
//     <Button
//       variant="contained"
//       color={confirm === 1 ? "primary" : "secondary"}
//       onClick={handleConfirm}
//     >
//       {confirm === 1 ? "Confirm" : "Deny"}
//     </Button>
//   );
// };

// const CancelButton = ({ appointment }) => {
//   const handleCancel = () => {
//     axios.delete(`${process.env.REACT_APP_API_BASE_URL}/appointments/${appointment.aid}`)
//       .then(() => alert("Appointment cancelled"))
//       .catch(err => console.error("Error cancelling appointment:", err));
//   };

//   return (
//     <Button variant="contained" color="secondary" onClick={handleCancel}>
//       Cancel
//     </Button>
//   );
// };

// const RescheduleButton = ({ appointment, setConfirm }) => {
//   const [open, setOpen] = useState(false);
//   const [newDate, setNewDate] = useState(appointment.date);
//   const [newTime, setNewTime] = useState(appointment.time);

//   const handleReschedule = () => {
//     axios.put(`${process.env.REACT_APP_API_BASE_URL}/appointments/${appointment.aid}`, {
//       ...appointment,
//       date: newDate,
//       time: newTime,
//       updatedAt: Date.now(),
//     })
//       .then(() => {
//         setConfirm(prev => !prev);
//         setOpen(false);
//       })
//       .catch(err => console.error("Error rescheduling:", err));
//   };

//   return (
//     <>
//       <Button variant="contained" onClick={() => setOpen(true)}>Reschedule</Button>
//       <Dialog open={open} onClose={() => setOpen(false)}>
//         <DialogTitle>Reschedule Appointment</DialogTitle>
//         <DialogContent>
//           <TextField
//             label="New Date"
//             type="date"
//             defaultValue={newDate}
//             onChange={e => setNewDate(e.target.value)}
//             fullWidth
//             margin="normal"
//           />
//           <TextField
//             label="New Time"
//             type="time"
//             defaultValue={newTime}
//             onChange={e => setNewTime(e.target.value)}
//             fullWidth
//             margin="normal"
//           />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpen(false)} color="primary">Cancel</Button>
//           <Button onClick={handleReschedule} color="primary">Reschedule</Button>
//         </DialogActions>
//       </Dialog>
//     </>
//   );
// };

// export default Schedule;











import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { app } from '../firebase/firebase-config';
import { getAuth } from 'firebase/auth';
import {
  Container, Box, Typography, Button, CircularProgress, Paper, Grid,
  Dialog, DialogTitle, DialogContent, DialogActions, TextField
} from '@material-ui/core';

const auth = getAuth(app);

const Schedule = () => {
  const [userDetails, setUserDetails] = useState({});
  const [view, setView] = useState("0");

  useEffect(() => {
    auth.onAuthStateChanged(async (user) => {
      if (user) {
        try {
          const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/users`);
          const matchedUser = res.data.find(i => i.email.toLowerCase() === user.email.toLowerCase());
          if (matchedUser) {
            setUserDetails(matchedUser);
          }
        } catch (err) {
          console.error("Error fetching users:", err);
        }
      }
    });
  }, []);

  return (
    <Container>
      {userDetails.account === 1 && (
        <>
          <Button onClick={() => setView("0")} style={{ backgroundColor: view === "0" ? "green" : "#9D96B8", marginRight: "20px" }}>
            View as Client
          </Button>
          <Button onClick={() => setView("1")} style={{ backgroundColor: view === "1" ? "green" : "#9D96B8" }}>
            View as Healer
          </Button>
        </>
      )}
      <ConfirmBox userDetails={userDetails} view={view} />
      <HistoryBox userDetails={userDetails} view={view} />
    </Container>
  );
};

const HistoryBox = ({ userDetails, view }) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  const endpoint = userDetails.account === 1 && view === "1"
    ? `appointments?healer=${userDetails.id}`
    : `appointments/clients/${userDetails.id}`;

  useEffect(() => {
    if (!userDetails.id) return;

    const fetchHistory = () => {
      axios.get(`${process.env.REACT_APP_API_BASE_URL}/${endpoint}`)
        .then(res => {
          setHistory(res.data);
          setLoading(false);
        })
        .catch(err => {
          console.error("Error fetching history:", err);
          setLoading(false);
        });
    };

    fetchHistory();

    const interval = setInterval(() => {
      if (localStorage.getItem('appointmentJustBooked') === 'true') {
        localStorage.removeItem('appointmentJustBooked');
        fetchHistory();
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [userDetails, view]);

  if (loading) return <CircularProgress />;

  return (
    <Box my={4}>
      <Typography variant="h5">Appointment History</Typography>
      {history.map((appointment, index) => (
        <Paper key={index} style={{ padding: 16, marginBottom: 16 }}>
          <ClientBox appointment={appointment} user={userDetails} />
        </Paper>
      ))}
    </Box>
  );
};

const ConfirmBox = ({ userDetails, view }) => {
  const [healerAppointment, setHealerAppointment] = useState([]);
  const [confirm, setConfirm] = useState(false);

  useEffect(() => {
    if (!userDetails.id) return;

    const url = view === "1"
      ? `${process.env.REACT_APP_API_BASE_URL}/appointments?healer=${userDetails.id}`
      : `${process.env.REACT_APP_API_BASE_URL}/appointments/clients/${userDetails.id}`;

    const fetchAppointments = async () => {
      let pending = [];

      try {
        const res = await axios.get(url);
        pending = res.data.filter(a => a.healerAccepted === null);
      } catch (err) {
        console.error("Error in ConfirmBox:", err);
      }

      const stored = localStorage.getItem('latestAppointment');
      if (stored) {
        const latest = JSON.parse(stored);
        latest.healerAccepted = null;
        pending.unshift(latest);
      }

      setHealerAppointment(pending);
    };

    fetchAppointments();
  }, [userDetails, view, confirm]);

  return (
    <Box my={4}>
      <Typography variant="h5">Upcoming Appointments</Typography>
      {healerAppointment.map((appointment, index) => (
        <Paper key={index} style={{ padding: 16, marginBottom: 16 }}>
          <ClientBox appointment={appointment} user={userDetails} />
          {!appointment.aid && (
            <Typography variant="body2" style={{ color: 'green' }}>
              Just Booked (not yet confirmed by server)
            </Typography>
          )}
          {view === "1" ? (
            <Grid container spacing={2}>
              <Grid item>
                <ConfirmButton appointment={appointment} confirm={1} healerID={userDetails.id} setConfirm={setConfirm} />
              </Grid>
              <Grid item>
                <ConfirmButton appointment={appointment} confirm={0} healerID={userDetails.id} setConfirm={setConfirm} />
              </Grid>
              <Grid item>
                <RescheduleButton appointment={appointment} setConfirm={setConfirm} />
              </Grid>
            </Grid>
          ) : (
            <CancelButton appointment={appointment} />
          )}
        </Paper>
      ))}
    </Box>
  );
};

const ClientBox = ({ appointment, user }) => {
  const [clientInfo, setClientInfo] = useState({});
  const endpoint = user.account === 1
    ? appointment.client ?? appointment.id
    : appointment.healer;

  useEffect(() => {
    if (!endpoint) return;

    axios.get(`${process.env.REACT_APP_API_BASE_URL}/users/${endpoint}`)
      .then(res => setClientInfo(res.data))
      .catch(err => console.error("Error fetching client info:", err));
  }, [endpoint]);

  return (
    <Box>
      <Typography variant="body1">
        {user.account === 1 ? "Healer" : "Client"}: {clientInfo.firstname} {clientInfo.lastname}
      </Typography>
      <Typography variant="body1">Time: {appointment.time}</Typography>
      <Typography variant="body1">Date: {appointment.date}</Typography>
      <Typography variant="body1">Service: {appointment.service || appointment.service_name}</Typography>
    </Box>
  );
};

const ConfirmButton = ({ appointment, confirm, healerID, setConfirm }) => {
  const handleConfirm = () => {
    axios.put(`${process.env.REACT_APP_API_BASE_URL}/appointments/${appointment.aid}`, {
      ...appointment,
      healerAccepted: confirm,
      healer: healerID,
      updatedAt: Date.now(),
    })
      .then(() => {
        setConfirm(prev => !prev);
      })
      .catch(err => console.error("Error confirming appointment:", err));
  };

  return (
    <Button
      variant="contained"
      color={confirm === 1 ? "primary" : "secondary"}
      onClick={handleConfirm}
    >
      {confirm === 1 ? "Confirm" : "Deny"}
    </Button>
  );
};

const CancelButton = ({ appointment }) => {
  const handleCancel = () => {
    axios.delete(`${process.env.REACT_APP_API_BASE_URL}/appointments/${appointment.aid}`)
      .then(() => alert("Appointment cancelled"))
      .catch(err => console.error("Error cancelling appointment:", err));
  };

  return (
    <Button variant="contained" color="secondary" onClick={handleCancel}>
      Cancel
    </Button>
  );
};

const RescheduleButton = ({ appointment, setConfirm }) => {
  const [open, setOpen] = useState(false);
  const [newDate, setNewDate] = useState(appointment.date);
  const [newTime, setNewTime] = useState(appointment.time);

  const handleReschedule = () => {
    axios.put(`${process.env.REACT_APP_API_BASE_URL}/appointments/${appointment.aid}`, {
      ...appointment,
      date: newDate,
      time: newTime,
      updatedAt: Date.now(),
    })
      .then(() => {
        setConfirm(prev => !prev);
        setOpen(false);
      })
      .catch(err => console.error("Error rescheduling:", err));
  };

  return (
    <>
      <Button variant="contained" onClick={() => setOpen(true)}>Reschedule</Button>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Reschedule Appointment</DialogTitle>
        <DialogContent>
          <TextField
            label="New Date"
            type="date"
            defaultValue={newDate}
            onChange={e => setNewDate(e.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            label="New Time"
            type="time"
            defaultValue={newTime}
            onChange={e => setNewTime(e.target.value)}
            fullWidth
            margin="normal"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="primary">Cancel</Button>
          <Button onClick={handleReschedule} color="primary">Reschedule</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Schedule;
